import { render, staticRenderFns } from "./COADetail.vue?vue&type=template&id=9e14d54a"
import script from "./COADetail.vue?vue&type=script&lang=js"
export * from "./COADetail.vue?vue&type=script&lang=js"
import style0 from "./COADetail.vue?vue&type=style&index=0&id=9e14d54a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports